import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import RatioContainer from 'components/consumer/RatioContainer';
import Placeholder from 'components/consumer/Placeholder';
import usePDPPhotos from 'data-hooks/usePDPPhotos';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import PDPDesktopMarxentConfigurator from 'components/consumer/modular-configurator/PDPMarxentConfigurator';
import PDPMobileConfigurationPhotoGalleryUI from './PDPMobileConfigurationPhotoGalleryUI';
const PDPMobileConfigurationPhotoGalleryInner = t0 => {
  const $ = _c(18);
  const {
    slug,
    isEditOrder: t1,
    pdpIsModularBYOProduct: t2,
    marxentPostHogFlag: t3,
    hideMarxent: t4,
    unavailableFabric: t5
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const marxentPostHogFlag = t3 === undefined ? false : t3;
  const hideMarxent = t4 === undefined ? true : t4;
  const unavailableFabric = t5 === undefined ? false : t5;
  const {
    loading: photosLoading,
    error: photosError,
    data: photosData
  } = usePDPPhotos(null, slug);
  const {
    loading: basicDetailsLoading,
    error: basicDetailsError,
    data: basicDetailsData
  } = usePDPBasicDetails();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  let modularPhotosData = useModularPDPPhotos(null, slug);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const {
    cylindoFeatures,
    isCylindoAvailable,
    loading: cylindoLoading,
    shouldShowDimensionThumbnail,
    upholsteryKey
  } = usePDPCylindoViewer();
  const {
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  if (photosLoading || cylindoLoading || basicDetailsLoading || pdpIsModularBYOProduct && modularPhotosData.loading) {
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
      $[0] = t6;
    } else {
      t6 = $[0];
    }
    return t6;
  }
  if (photosError || basicDetailsError) {
    return null;
  }
  const {
    configurationPhotos,
    isConfigFlipped,
    enableCrops
  } = pdpIsModularBYOProduct ? modularPhotosData.data : photosData;
  const {
    name
  } = basicDetailsData;
  if (!configurationPhotos.length) {
    return null;
  }
  let t6;
  if ($[1] !== configurationPhotos || $[2] !== cylindoFeatures || $[3] !== enableCrops || $[4] !== hideMarxent || $[5] !== isConfigFlipped || $[6] !== isCylindoAvailable || $[7] !== isEditOrder || $[8] !== marxentPostHogFlag || $[9] !== name || $[10] !== pdpIsModularBYOProduct || $[11] !== pdpSelectedCustomizerTab || $[12] !== shouldShowDimensionThumbnail || $[13] !== slug || $[14] !== unavailableFabric || $[15] !== upholsteryKey || $[16] !== viewGalleryImageEvent) {
    t6 = marxentPostHogFlag === "test" && pdpIsModularBYOProduct ? <PDPDesktopMarxentConfigurator pdpIsModularBYOProduct={pdpIsModularBYOProduct} slug={slug} key={slug} hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} /> : <PDPMobileConfigurationPhotoGalleryUI cylindoFeatures={cylindoFeatures} enableCrops={enableCrops} isConfigFlipped={isConfigFlipped} isCylindoAvailable={isCylindoAvailable} isEditOrder={isEditOrder} photos={configurationPhotos} productName={name} showDecideLaterOverlay={pdpSelectedCustomizerTab === "decide-later"} viewGalleryImageEvent={viewGalleryImageEvent} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} upholsteryKey={upholsteryKey} />;
    $[1] = configurationPhotos;
    $[2] = cylindoFeatures;
    $[3] = enableCrops;
    $[4] = hideMarxent;
    $[5] = isConfigFlipped;
    $[6] = isCylindoAvailable;
    $[7] = isEditOrder;
    $[8] = marxentPostHogFlag;
    $[9] = name;
    $[10] = pdpIsModularBYOProduct;
    $[11] = pdpSelectedCustomizerTab;
    $[12] = shouldShowDimensionThumbnail;
    $[13] = slug;
    $[14] = unavailableFabric;
    $[15] = upholsteryKey;
    $[16] = viewGalleryImageEvent;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
PDPMobileConfigurationPhotoGalleryInner.propTypes = {
  pdpIsModularBYOProduct: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  slug: PropTypes.string
};
const PDPMobileConfigurationPhotoGallery = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPMobileConfigurationPhotoGalleryInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPMobileConfigurationPhotoGallery;